module.exports = __webpack_public_path__ + "img/ft_milk_powder.7753e7bf.jpg";